import { slice } from '../slices/snackbar';

const nameSpace = slice.name;

/**
 * @param state
 * @returns {Array.<Object>}
 */
export const notifications = (state) => state[nameSpace].notifications;
/**
 * @param state
 * @returns <Object>
 */
export const palette = (state) => state[nameSpace].palette;
